import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const EyeIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M14.4364 7.23938C8.35605 0.843389 3.0347 5.59917 1.46683 7.31233C1.17558 7.63058 1.16799 8.09975 1.44736 8.42847C2.992 10.246 8.34305 15.4223 14.4577 8.50544C14.7776 8.14357 14.7691 7.58943 14.4364 7.23938Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <circle cx="8" cy="8" r="1.5" stroke="currentColor" strokeWidth="1.5" />
  </svg>
));
